import { render, staticRenderFns } from "./okrWorkSplit.vue?vue&type=template&id=2786fb95&scoped=true&"
import script from "./okrWorkSplit.vue?vue&type=script&lang=js&"
export * from "./okrWorkSplit.vue?vue&type=script&lang=js&"
import style0 from "./okrWorkSplit.vue?vue&type=style&index=0&id=2786fb95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786fb95",
  null
  
)

component.options.__file = "okrWorkSplit.vue"
export default component.exports